import m from "react";
import o from "react-dom";
import u from "@r2wc/core";
function c(e, t, n) {
  const r = m.createElement(t, n);
  return o.render(r, e), {
    container: e,
    ReactComponent: t
  };
}
function f({ container: e, ReactComponent: t }, n) {
  const r = m.createElement(t, n);
  o.render(r, e);
}
function i({ container: e }) {
  o.unmountComponentAtNode(e);
}
function p(e, t = {}) {
  return u(e, t, { mount: c, update: f, unmount: i });
}
export {
  p as default
};
